import React from 'react'
import {
  Box,
  Typography,
  Avatar,
  Divider,
} from "@mui/material";
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';

export default function ReplyCard({ review }) {

  return (
    <Box mt={3} p={2} borderRadius={3} bgcolor="#e6f4ea">
            <Typography variant="subtitle1" fontWeight={700} color="#0a7d40">
              Reply
            </Typography>
            {/* User */}
                <Box display="flex" alignItems="center" gap={2} mb={2}>
                <Avatar src={review?.reply?.admin?.profile ||
                      'https://picsum.photos/1017/917'} alt={review.reply.admin.name} />
                <Box>
                    <Typography variant="subtitle2" fontWeight={600}>{review.reply.admin.name} ({review.reply.admin.organisation})</Typography>
                    <Typography variant="caption" color="text.secondary">
                    {new Date(review.timestamp).toLocaleString()}
                    </Typography>
                </Box>
                </Box>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2" whiteSpace="pre-line" sx={{fontFamily:'Lato', fontStyle:'italic'}}>
          <FaQuoteLeft style={{ marginRight: 6, color: '#43a047', fontSize: 11 }} />        
              {review.reply.reply_text}
                    {'  '}
              <FaQuoteRight style={{ marginRight: 6, color: '#43a047', fontSize: 11}} />
            </Typography>
            
          </Box>
  )
}
